import { Endpoints } from "@brg/api";

export const getFlagUrl = (countryId: number) => {
    return `${Endpoints.files}/static/ftbl/flags/${countryId}.svg`;
}
import { Endpoints } from "@brg/api";

export const getFlagUrl = (countryId: number) => {
    return `${Endpoints.files}/static/ftbl/flags/${countryId}.svg`;
}
